/* MovieJSONBuilder.js */
/* @author: anghello */
/* v. 1.1 */

import Assets from "../services/Assets";

const FRAME_RATE = 30;

const defaultMovieJson = {
  'topic': '',
  'tiFont': '0',
  'tiSize': '124',
  'tiColor': '14601199',
  'BaPa': '0',
  'songId': '291', // main_song
  'BaRc': '51',
  'tiCommand': '13206', // tiC
  'BaRa': '0',
  'tiCommandDuration': '108', // tiCDur
  'tiFirstPhotoTime': '102', // tiFPT
  'BaPb': 'add',
  'tiScreenColor': '3612746', // tiSColor
  'BaPh': '7',
  'tiScreenAlpha': '0.8', // tiSAlpha
  'borderColor': '10919367', // botColor
  'tiScreenTOut': '102', // tiSTout * 30
  'BaCc': '65280',
  'BaCb': 'screen',
  'BaCx': '49',
  'BaPs': '333',
  'BaCa': '0',
  'tiVPos': '0', // ( if tiVPos exists include it )
  'borderType': '0', // borType
  'BaRb': 'overlay',
  'ssPattern': '3206', // main_pattern
  'BaBlur': '0',
  'BaCy': '-21',
  'tiTA': '0',
  'tiFPT': '3.4',
  // 'tiSTout': '3.4',
  'BaBlurLevel': '3',
  'tiX': '404',
  'tiY': '216',
  'tiTOverlay': '',
  'styleId': '11', // Style ID
  'username': '',
  'catId': '', // last category selected
  'songName': '', // name of the song
  'songBandName': '', // name of the band
  'BaName': '', // name of the background
  'styleName': '', // name of the style
  'catName': '', // last category name selected
  'geoLat': '', // geolocation latitude
  'geoLong': '', // geolocation longitude
  'songFilename': '00291-KM-Frost.mp3', // other json
  'perm': '3',
  'BaVScreenON': 'true',
  'tiTextAlpha': '1',
  'tiOFF': 'false',
  'backVideoLoc': '0514-HangingStars.flv', // json background
  'backImgLoc': '0514-HangingStars.jpg', // json background
  'BaID': '514', // json background
  'backType': '4', // json background
  'tiText': 'Movie Title', // movie name
  'albumJS': '', // static
  'backImgDataType': 'NaN', // static
  'logoEndLoc': '//movt11.pepblast.com/_pbv-assets/images/PepBlastLogoEnd.png', // static
  'promoImgLoc': '//www.photozig.com/_images/Slideshows-50x50.jpg', // static
  'logoOverlayLoc': '//movt11.pepblast.com/_pbv-assets/images/PepBlastLogoLightOnDark-25x87.png', // static
  'promoON': 'false', // static
  'logoEndON': 'true', // static
  'promoStart': '90', // static
  'promoDuration': '120', // static
  'promoTxt': 'COOL PEPBLAST Movie!', // static
  'promoLeft': '480', // static
  'promoTop': '70', // static
  'logoOverlayON': 'true' // static
}

export const MovieJSONBuilder = async ({ remixPars, allDataRemixPars, un, shouldAddSaveExportedVideoKey = false, saveExportedVideo, customSong = false, customSongEid, defaultImagesDurationFrames, defaultFrameRate, doShowVideos = true, doNotUseStageVideo = false, app, client }) => {
  const movieJson = defaultMovieJson;
  let categories, catName, catId;
  let styleId, styleSelect, generalStyleSelect;
  let songId, songSelect;

  if (allDataRemixPars && allDataRemixPars.getRemixApprovedElements) {
    if (allDataRemixPars.getRemixApprovedElements.its_styles && allDataRemixPars.getRemixApprovedElements.its_styles[0]) {
      const { estylesid } = allDataRemixPars.getRemixApprovedElements.its_styles[0];
      if (estylesid) { styleId = estylesid; }
    }

    if (allDataRemixPars.getRemixApprovedElements.its_songs && allDataRemixPars.getRemixApprovedElements.its_songs[0]) {
      const { esongsid } = allDataRemixPars.getRemixApprovedElements.its_songs[0];
      if (esongsid) { songId = esongsid; }
    }
  }

  if (styleId) {
    try {
      styleSelect = await Assets.getSingleStyle(styleId);
    } catch (err) {
      console.error(err);
    }

    try {
      categories = await Assets.getCategories();
    } catch (err) {
      console.error(err);
    }

    if (categories && categories.its && categories.its.length > 0) {
      categories.its.forEach((category) => {
        const { ts, la, id } = category;
        if (ts) {
          const splitted = ts.split(',');
          if (splitted && splitted.length > 0 && splitted.includes(`${styleId}`) && catName === undefined && catId === undefined) {
            catName = la;
            catId = id;
          }
        }
      });
    }
  }

  if (songId) {
    try {
      songSelect = await Assets.getSingleSong(songId);
    } catch (err) {
      console.error(err);
    }
  }

  if (catId) {
    try {
      const styles = await Assets.getStyle(catId);
      if (styles && styles.length > 0) {
        const filteredStyle = styles.filter((style) => parseInt(style.id) === parseInt(styleId));
        if (filteredStyle && filteredStyle.length > 0) { generalStyleSelect = filteredStyle[0]; }
      }
    } catch (err) {
      console.error(err);
    }
  }

  if (un !== undefined) {
    movieJson.username = un; // the username
    movieJson.producer = un; // the username
  }

  if (remixPars !== undefined) {
    if (remixPars.rperm !== undefined) {
      movieJson.perm = `${remixPars.rperm}`;
    }

    if (remixPars.rti !== undefined) {
      movieJson.tiText = remixPars.rti; // movie name
    }
  }

  if (styleId && styleSelect) {
    movieJson.styleId = `${styleId}`; // Style ID
    if (styleSelect.mc) { movieJson.catId = `${styleSelect.mc}`; }
    if (styleSelect.na) { movieJson.styleName = styleSelect.na; }
    if (styleSelect.ms) { movieJson.songId = styleSelect.ms; }
    if (styleSelect.bid) { movieJson.BaID = styleSelect.bid; }

    movieJson.catName = catName;

    if (generalStyleSelect) {
      if (generalStyleSelect.BaName) { movieJson.BaName = generalStyleSelect.BaName; }
      if (generalStyleSelect.backVideoLoc) { movieJson.backVideoLoc = generalStyleSelect.backVideoLoc; }
      if (generalStyleSelect.backImgLoc) { movieJson.backImgLoc = generalStyleSelect.backImgLoc; }
      if (generalStyleSelect.backType) { movieJson.backType = generalStyleSelect.backType; }
    }

    // Checking if is original song
    if (remixPars.uso && remixPars.usoid && customSong) {
      movieJson.songId = '_u_' + customSongEid;
      movieJson.songFilename = '_u_' + customSongEid + '.mp3';
      movieJson.songName = '';
      movieJson.songBandName = '';
    } else if (songSelect) {
      if (songSelect.na) { movieJson.songName = songSelect.na; }
      if (songSelect.bn) { movieJson.songBandName = songSelect.bn; }
      if (songSelect.lo) { movieJson.songFilename = songSelect.lo; }
    }

    if (styleSelect.tf) { movieJson.tiFont = styleSelect.tf; }
    if (styleSelect.ts) { movieJson.tiSize = styleSelect.ts; }
    if (styleSelect.tc) { movieJson.tiColor = styleSelect.tc; }
    if (styleSelect.tic) { movieJson.tiCommand = styleSelect.tic; }
    if (styleSelect.tsa) { movieJson.tiScreenAlpha = styleSelect.tsa; }

    if (styleSelect.tcd) { movieJson.tiCommandDuration = parseFloat(styleSelect.tcd) * FRAME_RATE; }
    if (styleSelect.tfp) { movieJson.tiFirstPhotoTime = parseFloat(styleSelect.tfp) * FRAME_RATE; }
    if (styleSelect.tt) { movieJson.tiScreenTOut = parseFloat(styleSelect.tt) * FRAME_RATE; }
    if (styleSelect.to) { movieJson.tiTOverlay = parseFloat(styleSelect.to) * FRAME_RATE; }
    
    if (styleSelect.tsc) { movieJson.tiScreenColor = styleSelect.tsc; }
    if (styleSelect.tx) { movieJson.tiX = styleSelect.tx; }
    if (styleSelect.ty) { movieJson.tiY = styleSelect.ty; }
    if (styleSelect.ta) { movieJson.tiTA = styleSelect.ta; }
    if (styleSelect.tfp) { movieJson.tiFPT = styleSelect.tfp; }

    if (styleSelect.tv) { movieJson.tiVPos = styleSelect.tv; }
    if (styleSelect.bc) { movieJson.borderColor = styleSelect.bc; }
    if (styleSelect.bt) { movieJson.borderType = styleSelect.bt; }

    if (styleSelect.bpa) { movieJson.BaPa = styleSelect.bpa; }
    if (styleSelect.brc) { movieJson.BaRc = styleSelect.brc; }
    if (styleSelect.bra) { movieJson.BaRa = styleSelect.bra; }
    if (styleSelect.bpb) { movieJson.BaPb = styleSelect.bpb; }
    if (styleSelect.bph) { movieJson.BaPh = styleSelect.bph; }
    if (styleSelect.bcc) { movieJson.BaCc = styleSelect.bcc; }
    if (styleSelect.bcb) { movieJson.BaCb = styleSelect.bcb; }
    if (styleSelect.bcx) { movieJson.BaCx = styleSelect.bcx; }
    if (styleSelect.bps) { movieJson.BaPs = styleSelect.bps; }
    if (styleSelect.bca) { movieJson.BaCa = styleSelect.bca; }
    if (styleSelect.brb) { movieJson.BaRb = styleSelect.brb; }
    if (styleSelect.bbl) { movieJson.BaBlur = styleSelect.bbl; }
    if (styleSelect.bcy) { movieJson.BaCy = styleSelect.bcy; }
    if (styleSelect.bbe) { movieJson.BaBlurLevel = styleSelect.bbe; }

    if (styleSelect.mp) { movieJson.ssPattern = styleSelect.mp; }
  }

  if (shouldAddSaveExportedVideoKey && !saveExportedVideo) { movieJson.saveExpVideo = '0'; }

  
  if (allDataRemixPars && allDataRemixPars.getRemixApprovedElements && allDataRemixPars.getRemixApprovedElements.its_media) {
    const photoTimeArray = [];
    const photoAnimationArray = [];
    const photoArray = [];

    const remixAnimationId = (allDataRemixPars.getRemixApprovedElements.its_styles[0]) ? allDataRemixPars.getRemixApprovedElements.its_styles[0].epasid : '';

    allDataRemixPars.getRemixApprovedElements.its_media.forEach((media) => {
      // Photo time
      if (media.etype === 1) {
        photoTimeArray.push(defaultImagesDurationFrames);
      } else if (media.etype === 2) {
        photoTimeArray.push(parseInt(defaultFrameRate * media.edu));
      }

      // Photo animation
      if (media.eaid) {
        photoAnimationArray.push(media.eaid);
      } else {
        photoAnimationArray.push(remixAnimationId);
      }

      // Photo array
      photoArray.push(media.eid);
    });

    movieJson.photoTimeDoUseArray = '1';
    movieJson.photoTimeArray = photoTimeArray;

    movieJson.photoAnimationDoUseArray = '1';
    movieJson.photoAnimationArray = photoAnimationArray;

    movieJson.photoArray = photoArray;
  }

  // Video clip sound allowed
  movieJson.inVideosDoNotUseAudio = remixPars.rmcsa ? '1' : '0';
  movieJson.videoDoMuteVideoSound = remixPars.rmcsa ? '1' : '0';

  if (doShowVideos) {
    movieJson.videoDoShowVideos = 1;
    movieJson.videoDoNotUseStageVideo = doNotUseStageVideo ? 1 : 0;

    movieJson.videoBaseLoc = 'file://;';
    movieJson.videoFirstFramePars = [{ 'Fs': 1, 'Fe': 1, 'dcps': 2, 'dsvout': 1 }];

    // movieJson.videoArray = videoArray   ;
  }
  
  movieJson.app = app;
  movieJson.client = client;
  movieJson.custom = '0';
  movieJson.backT3F = '0';
  movieJson.backT3ease = '0';
  
  // Other parameters

  // movieJson.deviceNativeHeight
  // movieJson.deviceNativeWidth
  // movieJson.fullPortraitDoOperation
  // movieJson.fullPortraitPars: [ { "height": 926, "width": 428 } ]

  // movieJson.height
  // movieJson.maxFrames
  // movieJson.maxPhotoLoadNumber
  
  return movieJson;
}
